import React from "react";
import { useNavigate } from "react-router-dom";
import PropertyImageUpload from "../components/PropertyImageUpload";

const analyzeSteps = [
    { number: 1, label: 'Dónde y quién eres', path: '/analizarpropiedad/:id/paso1' },
    { number: 2, label: 'Imágenes', path: '/analizarpropiedad/:id/imagenes' },
    { number: 3, label: 'Información básica', path: '/analizarpropiedad/:id/datos' },
    { number: 4, label: 'Recibir informe', path: '/analizarpropiedad/:id/informe' }
];

const AnalyzePropertyImages = () => {
    const navigate = useNavigate();

    return (
        <div className="container mx-auto px-4 py-8">
            <PropertyImageUpload
                steps={analyzeSteps}
                currentStep={2}
                navigateOnFinish={(id) => navigate(`/analizarpropiedad/${id}/datos`)}
                finishButtonText="Siguiente: Información básica"
                finishToastMessage="Imágenes guardadas correctamente."
            />
        </div>
    );
};

export default AnalyzePropertyImages;
